import { render } from "./LegendIcon.vue?vue&type=template&id=0f4a6d86&ts=true"
import script from "./LegendIcon.vue?vue&type=script&lang=ts"
export * from "./LegendIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__